// extracted by mini-css-extract-plugin
export default {"base":"vp_oKMzD","backgroundMove":"vp_n4g17"};